import type { ReportQueryResponse } from '@/api/types';

const INTEGRITY_MESSAGE =
  'Performance data did not satisfy the assigned-production-only contract. Values and export are withheld.';

function metricSetIsDirect(metrics: ReportQueryResponse['totals']): boolean {
  return metrics.halo_conversions_micros === 0
    && metrics.halo_revenue_micros === 0
    && metrics.halo_tickets === 0
    && metrics.halo_revenue_cents === 0
    && metrics.attributed_conversions_micros === metrics.assigned_conversions_micros
    && metrics.attributed_revenue_micros === metrics.assigned_revenue_micros
    && metrics.net_tickets === metrics.assigned_tickets
    && metrics.net_revenue_cents === metrics.assigned_revenue_cents
    && Math.abs(metrics.total_roas - metrics.assigned_roas) < 0.000001
    && Math.abs(metrics.billable_roas - metrics.assigned_roas) < 0.000001;
}

/**
 * Fail closed at the presentation boundary. The API owns filtering, but this
 * guard ensures a future request-builder or backend regression cannot turn an
 * internal all-effect response into a report shown or exported to a client.
 */
export function directPerformanceIntegrityError(
  response: ReportQueryResponse | undefined,
): string | null {
  if (!response) return null;
  if (response.methodology.attribution_scope !== 'direct_only') {
    return INTEGRITY_MESSAGE;
  }
  if (!metricSetIsDirect(response.totals)) return INTEGRITY_MESSAGE;
  if (response.rows.some((row) => !metricSetIsDirect(row.metrics))) {
    return INTEGRITY_MESSAGE;
  }
  return null;
}
